/* eslint-disable @next/next/no-img-element */
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import StaticTooltip from '@/components/StaticTooltip/StaticTooltip';
import { REGISTER_STORAGE_URL } from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

const partnerKeys = ['hladeko', 'delfin', 'urbanfish', 'tihij-okean', 'dalkomholod'];
const citiesArr = [
	{
		mainTitleKey: 'arkhangelsk',
		firstTitle: '5',
		secondTitle: '60%',
		tooltipPosition: 'right',
		style: { top: '1rem', left: '32.44rem' },
	},
	{
		mainTitleKey: 'petropavlovsk-kamchatsky',
		firstTitle: '10',
		secondTitle: '80%',
		tooltipPosition: 'top',
		style: { top: '9.1rem', right: '10.7rem' },
	},
	{
		mainTitleKey: 'vladivostok',
		firstTitle: '10',
		secondTitle: '65%',
		tooltipPosition: 'top',
		style: { top: '34.7rem', right: '22.8rem' },
	},
	{
		mainTitleKey: 'novosibirsk',
		firstTitle: '5',
		secondTitle: '45%',
		tooltipPosition: 'top',
		style: { top: '30rem', left: '54rem' },
	},
];

export default function StorageStatistics() {
	const router = useRouter();
	const t = useTranslation(TranslationNamespace.Marketing).t;
	const navigateToRegistration = () => router.push(REGISTER_STORAGE_URL);
	const prefetchRegistration = () => router.prefetch(REGISTER_STORAGE_URL);

	return (
		<section className="storage-section4">
			<div className="containerWarehouse">
				<div className="storage-section4__inner">
					<div className="hide-sm">
						{citiesArr.map(({ mainTitleKey, ...props }) => (
							<StaticTooltip
								key={mainTitleKey}
								{...props}
								mainTitle={t(`storage.storage-statistics.${mainTitleKey}`)}
								firstSubtitle={t('storage.storage-statistics.warehouses')}
								secondSubtitle={t('storage.storage-statistics.average-workload')}
							/>
						))}

						<StaticTooltip onlyDot style={{ top: '2rem', left: '66.8rem' }} />

						<StaticTooltip onlyDot style={{ top: '10rem', left: '81rem' }} />

						<StaticTooltip onlyDot style={{ top: '12.6rem', left: '97rem' }} />

						<StaticTooltip onlyDot style={{ top: '25.3rem', left: '70.7rem' }} />
					</div>

					<div className="sm-only">
						<StaticTooltip
							mainTitle={t('storage.storage-statistics.vladivostok')}
							firstTitle="10"
							firstSubtitle={t('storage.storage-statistics.warehouses')}
							secondTitle="65%"
							secondSubtitle={t('storage.storage-statistics.average-workload')}
							tooltipPosition="top"
							style={{ top: '-7.1rem', left: '12.1rem' }}
						/>

						<StaticTooltip onlyDot style={{ top: '-10.7rem', left: '2.2rem' }} />
						<StaticTooltip onlyDot style={{ top: '-28.7rem', left: '0.6rem' }} />
						<StaticTooltip onlyDot style={{ top: '-35.1rem', left: '14.9rem' }} />
						<StaticTooltip onlyDot style={{ top: '-35.1rem', left: '14.9rem' }} />
						<StaticTooltip onlyDot style={{ top: '-25.3rem', left: '12.1rem' }} />
						<StaticTooltip onlyDot style={{ top: '-25.3rem', left: '23.6rem' }} />
						<StaticTooltip onlyDot style={{ top: '-25.3rem', left: '28.6rem' }} />
					</div>

					<img
						className="storage-section4__gradient-map hide-sm"
						src="/img/svg/adaptive-gradient-map.svg"
						alt=""
					/>

					<img
						className="storage-section4__gradient-map sm-only"
						src="/img/svg/gradient-map.svg"
						alt=""
					/>

					<div className="storage-section4__title-container">
						<h2
							className="section-title"
							dangerouslySetInnerHTML={{
								__html: t('storage.storage-statistics.we-work-with-br-most-warehouses-in-russia'),
							}}
						/>

						<span className="section-subtitle">
							{t('storage.storage-statistics.expanding-our-geographical-presence')}
						</span>
					</div>

					<div className="storage-section4__total-list">
						<ul>
							<li>
								<span>130</span> {t('storage.storage-statistics.warehouses-connected')}
							</li>

							<li>
								<span>20</span> {t('storage.storage-statistics.cities-of-russia')}
							</li>
						</ul>
					</div>

					<div className="storage-section4__button-container hide-sm">
						<Button
							size="large"
							type="primary"
							onClick={navigateToRegistration}
							onFocus={prefetchRegistration}
							onMouseEnter={prefetchRegistration}
						>
							{t('storage.storage-statistics.register-a-warehouse')}
						</Button>
					</div>

					<div className="storage-section4__parthners-list">
						<span className="storage-section4__parthners-list-title">
							{t('storage.storage-statistics.we-work-with')}
						</span>

						<ul>
							{partnerKeys.map((item, index) => {
								const number = index + 1 <= 3 ? index + 1 : 2;

								return (
									<li key={index}>
										<span>
											<img src={`/img/svg/fish${number}.svg`} alt="" />
											{t(`storage.storage-statistics.${item}`)}
										</span>
									</li>
								);
							})}
						</ul>
					</div>

					<div className="storage-section4__button-container sm-only">
						<Button
							onClick={navigateToRegistration}
							onFocus={prefetchRegistration}
							onMouseEnter={prefetchRegistration}
						>
							{t('storage.storage-statistics.register-a-warehouse')}
						</Button>
					</div>
				</div>

				<div className="storage-section5__title-block sm-only">
					<img src="/img/svg/fish-home.svg" alt="" />

					<div className="storage-section5__title-block-content">
						<span className="storage-section5__title-block_small">
							{t('storage.storage-statistics.more')}
						</span>

						<h2>4 880 000 {t('storage.storage-statistics.t')}</h2>

						<span>
							{t('storage.storage-statistics.capacity-potential-of-the-fishplace-platform')}
						</span>
					</div>
				</div>
			</div>

			{/*Storage-section5_absolute*/}
			<div className="container mt-[10rem]">
				<div className="storage-section5__inner">
					<div className="storage-section5__title-block hide-sm">
						<div className="storage-section5__title-block-content">
							<span className="storage-section5__title-block_small">
								{t('storage.storage-statistics.more')}
							</span>

							<h2>4 880 000 {t('storage.storage-statistics.t')}</h2>

							<span>
								{t('storage.storage-statistics.capacity-potential-of-the-fishplace-platform')}
							</span>
						</div>

						<img src="/img/svg/fish-home.svg" alt="" />
					</div>
				</div>
			</div>
		</section>
	);
}
